import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RFQ } from '@app/core/quotes';
import { OrderSalesApiService } from 'v2/modules/shared/services/api/order/order-sales-api.service';
import { trackById } from 'v2/modules/shared/util/track-by.util';

@Component({
  selector: 'lum-rfq-inventory-orders-table',
  templateUrl: './rfq-inventory-orders-table.component.html',
  styleUrls: ['./rfq-inventory-orders-table.component.scss'],
})
export class RfqInventoryOrdersTableComponent implements OnInit, OnDestroy {
  loading$ :BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  incomingOrders :any[] = [];
  relations :string = [
    'supplierPurchaseOrder',
    'supplierPurchaseOrder.factory',
  ].join(',');

  trackById = trackById;

  private onDestroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data :{ rfq :RFQ; warehouseId :number },
    private dialogRef :MatDialogRef<RfqInventoryOrdersTableComponent>,
    private orderSalesApiService :OrderSalesApiService,
    private router :Router,
  ) {}

  ngOnInit() :void {
    this.getIncomingTransactions();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onClose() :void {
    this.dialogRef.close();
  }

  onViewOrder(order :any) :void {
    if (order?.supplierPurchaseOrder) {
      this.router.navigate(['/orders', order?.purchaseOrderId]);
    }

    this.onClose();
  }

  private getIncomingTransactions() :void {
    this.loading$.next(true);
    const payload = {
      rfqId: this.data?.rfq.id,
      relations: this.relations,
    };

    if (this.data.warehouseId) {
      payload['warehouseId'] = this.data.warehouseId;
    }

    this.orderSalesApiService
      .getSalesOrderItemIncomingTransactions(payload)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: (orders) => {
          this.incomingOrders = orders;
        },
        error: (err) => {
          console.error('err', err);
        },
        complete: () => {
          this.loading$.next(false);
        },
      });
  }
}
